import React, { useEffect, useState } from 'react';
import "./../styles/myprofile.css"
import MyProfileMain from './profile_pages/MyProfileMain';
import MyProfileStrategies from './profile_pages/MyProfileStrategies';
import MyProfileTipps from './profile_pages/MyProfileTipps';
import MyProfileFollows from './profile_pages/MyProfileFollows';
import MyProfileSettings from './profile_pages/MyProfileSettings';
import MyProfilePosts from './profile_pages/MyProfilePosts';
import { useParams } from 'react-router-dom';

export default function MyProfile({ addToast }) {
    const [page, setPage] = useState("main");
    const [isLoggedIn, setIsLoggedIn] = useState(true);

    const [myUsername, setMyUsername] = useState("poracz");
    const { username: targetUsername } = useParams();
    const isOwnProfile = myUsername && myUsername === targetUsername;


    //TITLE BEÁLLITÁS
    useEffect(() => {
        document.title = "Profilom - FociFanatik"
    }, []);


    useEffect(() => {
        setPage("main");
    }, [targetUsername]);

    useEffect(() => {
        fetch("https://focifanatik.hu/api/session_check.php", {
            credentials: "include"
        })
            .then(res => res.json())
            .then(data => {
                if (!data.loggedIn) {
                    // window.location.href = "/regisztracio";
                }
                else if (data.loggedIn) {
                    setIsLoggedIn(true);
                    setMyUsername(data.username);
                }
            });
    }, []);



    return (
        <div className='myProfilePage'>

            {/* SIDEBAR ATTÓL FÜGGŐEN HOGY SAJÁT PROFIL VAGY SEM */}
            <aside className='myProfilePage-sideMenu'>
                <button onClick={() => setPage("main")}>
                    <i className="bi bi-person"></i>
                    <span>{isOwnProfile ? "Profilom" : "Profil"}</span>
                </button>

                {isOwnProfile && (
                    <button onClick={() => setPage("strategies")}>
                        <i className="bi bi-bar-chart"></i>
                        <span>Stratégiáim</span>
                    </button>
                )}

                <button onClick={() => setPage("tipps")}>
                    <i className="bi bi-bar-chart"></i>
                    <span>Tippjáték</span>
                </button>

                <button onClick={() => setPage("follows")}>
                    <i className="bi bi-people"></i>
                    <span>{isOwnProfile ? "Követéseim" : "Követései"}</span>
                </button>

                <button onClick={() => setPage("posts")}>
                    <i className="bi bi-image"></i>
                    <span>Posztok</span>
                </button>

                {isOwnProfile && (
                    <button onClick={() => setPage("settings")}>
                        <i className="bi bi-gear"></i>
                        <span>Beállítások</span>
                    </button>
                )}
            </aside>





            {page === "main" && <MyProfileMain addToast={addToast} />}
            {page === "strategies" && isOwnProfile && <MyProfileStrategies />}
            {page === "tipps" && <MyProfileTipps />}
            {page === "follows" && <MyProfileFollows />}
            {page === "settings" && isOwnProfile && <MyProfileSettings addToast={addToast} />}
            {page === "posts" && <MyProfilePosts />}


        </div >
    );
}